import StyledCard from "components/UI/StyledCard";
import { GridColDef } from "@mui/x-data-grid-premium";
import { useMemo } from "react";
import { OPERATORS } from "../LandingPages/data/constants";
import { CopyValueCell } from "./common/CopyValueCell";
import { getProgramExclusionRows, isTopLevelProgramExclusionRow, ProgramExclusionRow } from "./data/helper";
import TreeDataGrid from "./common/TreeDataGrid";
import { useOrbit } from "providers/OrbitProvider";
import Tooltip from "@mui/material/Tooltip";
import { isPresent } from "lib/utils";
import clsx from "clsx";


const programExclusionRuleColumns: GridColDef<ProgramExclusionRow>[] = [
  {
    field: 'fieldName',
    groupable: true,
    headerName: 'Field',
    flex: 2,
    cellClassName: ({ row }) => clsx('bold', { 'code-text': !isTopLevelProgramExclusionRow(row) }),
    valueGetter: (_value, row) => (isTopLevelProgramExclusionRow(row) ? row.programName : row.fieldName),
    rowSpanValueGetter: (_value, row: ProgramExclusionRow) => row.fieldName,
    colSpan: (_value, row) => (isTopLevelProgramExclusionRow(row) ? 2 : undefined),
  },
  {
    field: 'operator',
    groupable: false,
    headerName: 'Operator',
    cellClassName: 'bold',
    valueGetter: (value) => OPERATORS.find((operator) => operator.id === value)?.value ?? value,
    valueFormatter: (value) => OPERATORS.find((operator) => operator.id === value)?.value ?? (value ?? ''),
    flex: 3,
  },
  {
    field: 'value',
    groupable: false,
    headerName: 'Value',
    flex: 2,
    cellClassName: 'code-text bold',
    valueGetter: (_value, row) => (isTopLevelProgramExclusionRow(row) ? row.programCode : row.value),
    renderCell: CopyValueCell,
    valueFormatter: (value) => (value ?? ''),
  },
  {
    field: 'text',
    groupable: false,
    headerName: 'Value Detail',
    flex: 2,
  },
  {
    field: 'time',
    groupable: false,
    headerName: 'Time',
    renderCell: ({ value }) => (isPresent(value) ? <Tooltip title={value}>{value}</Tooltip> : value),
    valueFormatter: (value) => (value ?? ''),
    flex: 3,
  },
  {
    field: '__tree_data_group__', // The grouping column (used to order it last)
    width: 100
  }
]

export function ProgramLevelExclusionRules({degreePrograms, clientTimezone}) {
  const { store, getRemoteId } = useOrbit()

  const rows = useMemo(() => getProgramExclusionRows({
    store,
    degreePrograms: degreePrograms,
    getRemoteId,
    clientTimezone,
  }), [degreePrograms, getRemoteId, store, clientTimezone])

  return (
    <StyledCard
      title='Program-Level Exclusion Rules'
      isSubsection={true}
    >
      <TreeDataGrid
        rows={rows}
        columns={programExclusionRuleColumns}
        enableRowSpanning={true}
        exportRegistration={{ id: 'program-exclusions', sheetName: 'Program Exclusions', order: 3, rowSpanFields: ['fieldName', 'operator'], rowSpanGroupByField: 'fieldName' }}
      />
    </StyledCard>
  )
}
